import React from 'react';
import PropTypes from 'prop-types';
import { PriceRrp } from './price/price_rrp';
import { PricePerPiece } from './price/price_per_piece';
import { PriceBuy4Pay3 } from './price/price_buy4pay3';
import { PercentageDiscountPrice } from './price/percentage_discount.js';
import { AmountDiscountPrice } from './price/amount_discount.js';
import { featureFlags } from '../../../../_constants/feature_flags';
import { Sca25PercentDiscount } from './price/price_sca_25_percent_discount';
import Translation from '../../translation/translation';
import { show } from '../../../actions/clearance_info_light_box_actions';

const { FEATURE_PRICE_RRP } = featureFlags;
const DISCOUNT = {
  AMOUNT: 'amount',
  PERCENTAGE: 'percentage',
};
const getClearancePill = (badges) => badges.findIndex((x) => x.type === 'clearance');
const shouldDisplayBuy4Pay3 = (buy4pay3) => featureFlags.FEATURE_TYRE_DEALS && buy4pay3 === true;
const _isPriceDiscountApplied = (discount) =>
  (discount && Object.prototype.hasOwnProperty.call(discount, 'discountValue') && discount.discountValue > 0) || false;

export const Price = ({ price, priceRrp, priceRaw, currencyIsoCode, buy4for3, priceDiscount, badges }) => (
  <>
    {getClearancePill(badges) > -1 ? (
      <Translation translationKey="badge-clearance" className="sale-price__tag sale-price__tag--clearance" onClick={show} />
    ) : (
      <></>
    )}
    <div className="product-tile__price product-tile">
      {FEATURE_PRICE_RRP && priceRrp !== '' && <PriceRrp price={priceRrp} />}

      <PricePerPiece
        price={price}
        priceRrp={priceRrp}
        hasBuy4Pay3={
          shouldDisplayBuy4Pay3(buy4for3) ||
          featureFlags.FEATURE_SCA_25_PERCENT_DISCOUNT ||
          (_isPriceDiscountApplied(priceDiscount) && priceDiscount.discountType === DISCOUNT.PERCENTAGE) ||
          (_isPriceDiscountApplied(priceDiscount) && priceDiscount.discountType === DISCOUNT.AMOUNT)
        }
      />

      {!_isPriceDiscountApplied(priceDiscount) && featureFlags.FEATURE_SCA_25_PERCENT_DISCOUNT && (
        <Sca25PercentDiscount priceRaw={priceRaw} currencyIsoCode={currencyIsoCode} />
      )}

      {_isPriceDiscountApplied(priceDiscount) && priceDiscount.discountType === DISCOUNT.AMOUNT && (
        <AmountDiscountPrice
          priceRaw={priceRaw}
          discount={priceDiscount.discountValue}
          discountValuePerItem={priceDiscount.discountValuePerItem}
          currencyIsoCode={currencyIsoCode}
        />
      )}

      {_isPriceDiscountApplied(priceDiscount) && priceDiscount.discountType === DISCOUNT.PERCENTAGE && (
        <PercentageDiscountPrice
          priceRaw={priceRaw}
          discount={priceDiscount.discountValue}
          currencyIsoCode={currencyIsoCode}
        />
      )}

      {!_isPriceDiscountApplied(priceDiscount) && shouldDisplayBuy4Pay3(buy4for3) && (
        <PriceBuy4Pay3 priceRaw={priceRaw} currencyIsoCode={currencyIsoCode} />
      )}
    </div>
  </>
);

Price.propTypes = {
  priceRaw: PropTypes.number.isRequired,
  price: PropTypes.string.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  onSeeHowItWorksClick: PropTypes.func.isRequired,
  priceRrp: PropTypes.string,
  buy4for3: PropTypes.bool,
};

Price.defaultProps = {
  priceRrp: '',
};
